import { toSafeNullableString } from '@shared/utils';

const normalizeProjectId = (value) => {
  return toSafeNullableString(value);
};

export default normalizeProjectId;
